/**
 * @generated SignedSource<<50f10a3c20afcdf5f0a4d2d85b91c2e2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TimeBudgetData_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TimeChart_project" | "TimeTotals_project" | "HighLevelTimeNumbers_project">;
  readonly " $fragmentType": "TimeBudgetData_project";
};
export type TimeBudgetData_project$key = {
  readonly " $data"?: TimeBudgetData_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimeBudgetData_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeBudgetData_project",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimeChart_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimeTotals_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HighLevelTimeNumbers_project"
    }
  ],
  "type": "ProjectType",
  "abstractKey": null
};

(node as any).hash = "42d06d0369167517d827b9863fd4911b";

export default node;
